import axios from 'axios';
import { ifIsDevConsoleLog } from './helper';

const functions = {};

functions.capitalizeFirstLetter = (string) => string.charAt(0)
  .toUpperCase() + string.slice(1);

functions.makeid = () => {
  let i = 0;
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let text = '';
  while (i < 10) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
    i++;
  }
  return text;
};

functions.slugify = (text) => text.toString()
  .toLowerCase()
  .replace(/\s+/g, '-')
  .replace(/[^\w\-]+/g, '')
  .replace(/\-\-+/g, '-')
  .replace(/^-+/, '')
  .replace(/-+$/, '');

functions.addEvent = (obj, evt, fn) => {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent(`on${evt}`, fn);
  }
};

functions.stripHtmlComments = (content) => content.replace(/<!--(?!>)[\S\s]*?-->/g, '');

functions.parseUri = (path) => {
  const parser = document.createElement('a');
  parser.href = path;
  return parser;
};

functions.debounce = (func) => {
  let timer = 0;
  return (event) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, 100, event);
  };
};

functions.getOffset = (el) => {
  const elm = el.getBoundingClientRect();
  return {
    left: elm.left + window.scrollX,
    top: elm.top + window.scrollY,
  };
};

function emailDaGeeks(FormObject) {
  axios.post('/app/api/bug/geeks', FormObject,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      ifIsDevConsoleLog(response, 'ers');
    })
    .catch((error) => {
      ifIsDevConsoleLog(error, 'erf');
    });
}
const excludedPrefixes = [
  'https://paulbunyan.net/',
  'https://webmail.paulbunyan.net/',
  'https://pbc2017.pbndev.net/',
  'https://webmail.pbc2017.pbndev.net/',
  'https://pbc2017.localhost/',
  'https://web.test',
  'https://webmail.pbc2017.localhost/',
  'https://help.paulbunyan.net/',
  'https://www.linkedin.com/company/paul-bunyan',
  'https://supportchat.us/pbcs/mibew/client.php?',
  'https://www.facebook.com/paulbunyancommunications',
  'https://www.gigazonegaming.com/',
  'https://wordpress.org/',
  'https://browser-update.org/',
  'https://learn.wordpress.org/',
  'https://www.instagram.com/paulbunyancommunications',
  'https://www.tiktok.com/@paulbunyancommunications',
  'https://twitter.com/paulbunyanComm',
  'https://goo.gl/maps/gYbXtovCL3N1jAAf7',
  'https://goo.gl/maps/BkhfdPrKYVt',
  'https://gigazone.com/',
];
const excludeExact = [
  'tel:8885863100',
  'tel:888-586-3100',
  'tel:2184441234',
  'tel:218-444-1234',
  'tel:2189991234',
  'tel:218-999-1234',
  'wordpress.org',
];

functions.getAllLinks = () => {
  const anchors = document.getElementsByTagName('a');
  let check = false;
  const form = new FormData();
  form.append('URL where the issue was found:', window.location);
  for (let i = 0; i < anchors.length; i++) {
    const { href, id, textContent } = anchors[i];
    // const text = anchors[i].textContent;
    let existsInExclude = false;
    const hyperlink = href.toLowerCase().trim().replace('https://TheKeeper@', 'https://');

    for (let j = 0; j < excludedPrefixes.length; j++) {
      if (hyperlink.startsWith(excludedPrefixes[j].toLowerCase())) {
        existsInExclude = true;
        break;
      }
    }
    if (!existsInExclude) {
      for (let j = 0; j < excludeExact.length; j++) {
        if (hyperlink === excludeExact[j].toLowerCase()) {
          existsInExclude = true;
          break;
        }
      }
    }
    if (hyperlink.includes('six.paulbunyan')) {
      check = true;
      form.append('six.paulbunyan menu error', 'six.paulbunyan is showing up on the menu again :(');
      form.append(`Element ${i} - id:`, id);
      form.append(`Element ${i} - link:`, href);
      form.append(`Element ${i} - text:`, textContent);
      form.append(`${i}`, `------------------------------------------------------------- ${i}`);
    } else if (hyperlink !== ''
      && !existsInExclude
    ) {
      check = true;
      form.append(`${i} Warning!`, `Unrecognized Link! Please make sure this link is ours! ${i}`);
      form.append(`${i} Link:`, href);
      if (id.trim() !== '') {
        form.append(`${i} ID:`, id);
      } else {
        form.append(`${i} ID:`, 'Link had no id.');
      }
      if (textContent.trim() !== '') {
        form.append(`${i} Text:`, id);
      } else {
        form.append(`${i} Text:`, 'Link had no text content.');
      }
      form.append(`${i}`, `------------------------------------------------------------- ${i}`);
    }
  }
  if (check) {
    emailDaGeeks(form);
  }
};
export default functions;
